import { Route, Switch } from "react-router-dom";

import AdsManager20VKbPage from "@faire/prototype-playground/workspace/kev/ads-manager-2-vkb";

export function KevinBenscheidtRoutes() {
  return (
    <Switch>
      <Route path="/kev/ads-manager-2-vkb" component={AdsManager20VKbPage} />
    </Switch>
  );
}

export const slug = "kev";
